export default "__VITE_ASSET__Jq8pyIyf__"